(function () {
  'use strict';

  if (window.UnifiedSchema) {
    return;
  }

  const VERSION = '1.2.0';

  const FIELD_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
    ARRAY: 'array'
  };

  const NORMALIZERS = {
    TRIM: 'trim',
    LOWERCASE: 'lowercase',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    PHONE: 'phone',
    EMAIL: 'email'
  };

  const coreFields = {
    ut_session_id: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'bigquery',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    page_sequence: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'metric',
      normalize: [
        NORMALIZERS.NUMBER
      ]
    },

    page_location: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    page_path: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    page_title: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    page_language: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },

    page_loaded_at: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    time_since_page_load: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.NUMBER
      ]
    },

    seconds_since_page_load: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'metric',
      normalize: [
        NORMALIZERS.NUMBER
      ]
    },

    scroll_depth: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0,
      maximum: 100
    },

    referrer_domain: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },

    navigation_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },

    event_timestamp: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },

    event_category: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },

    service: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },

    conversion_candidate: {
      type: FIELD_TYPES.BOOLEAN,
      required: true,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    }
  };

  const eventSchemas = {
    section_view: {
      category: 'engagement',

      required: [
        'section_name',
        'section_index',
        'visibility_ratio'
      ],

      optional: [
        'section_id',
        'section_type',
        'section_source',
        'section_selector',
        'visible_ms'
      ],

      fields: {
        section_name: {
          type: FIELD_TYPES.STRING,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_index: {
          type: FIELD_TYPES.NUMBER,
          required: true,
          analytics: 'metric',
          normalize: [
            NORMALIZERS.NUMBER
          ],
          minimum: 0
        },

        section_id: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_type: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM,
            NORMALIZERS.LOWERCASE
          ]
        },

        section_source: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'internal',
          normalize: [
            NORMALIZERS.TRIM,
            NORMALIZERS.LOWERCASE
          ]
        },

        section_selector: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'internal',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        visibility_ratio: {
          type: FIELD_TYPES.NUMBER,
          required: true,
          analytics: 'metric',
          normalize: [
            NORMALIZERS.NUMBER
          ],
          minimum: 0,
          maximum: 1
        },

        visible_ms: {
          type: FIELD_TYPES.NUMBER,
          required: false,
          analytics: 'metric',
          normalize: [
            NORMALIZERS.NUMBER
          ],
          minimum: 0
        }
      }
    },

    phone_grooming: {
      category: 'lead',

      required: [
        'phone_number',
        'click_location'
      ],

      optional: [
        'link_text',
        'link_url',
        'cta_label',
        'section_name'
      ],

      fields: {
        phone_number: {
          type: FIELD_TYPES.STRING,
          required: true,
          analytics: 'excluded_sensitive',
          normalize: [
            NORMALIZERS.TRIM,
            NORMALIZERS.PHONE
          ]
        },

        link_text: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'internal',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        link_url: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'excluded_sensitive',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        click_location: {
          type: FIELD_TYPES.STRING,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        cta_label: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_name: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        }
      }
    },

    phone_hotel: {
      inherit: 'phone_grooming',
      category: 'lead'
    },

    phone_veterinar: {
      inherit: 'phone_grooming',
      category: 'lead'
    },

    email_hotel: {
      category: 'lead',

      required: [
        'click_location'
      ],

      optional: [
        'email_address',
        'link_text',
        'link_url',
        'cta_label',
        'section_name'
      ],

      fields: {
        email_address: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'excluded_sensitive',
          normalize: [
            NORMALIZERS.TRIM,
            NORMALIZERS.EMAIL
          ]
        },

        link_text: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'internal',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        link_url: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'excluded_sensitive',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        click_location: {
          type: FIELD_TYPES.STRING,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        cta_label: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_name: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        }
      }
    },

    whatsapp_click: {
      category: 'lead',

      required: [
        'click_location'
      ],

      optional: [
        'cta_label',
        'section_name'
      ],

      fields: {
        click_location: {
          type: FIELD_TYPES.STRING,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        cta_label: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_name: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        }
      }
    },

    contact_form_submit: {
      category: 'lead',

      required: [
        'has_phone',
        'has_email',
        'message_length'
      ],

      optional: [
        'has_pet_name',
        'form_location',
        'section_name'
      ],

      fields: {
        has_phone: {
          type: FIELD_TYPES.BOOLEAN,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.BOOLEAN
          ]
        },

        has_email: {
          type: FIELD_TYPES.BOOLEAN,
          required: true,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.BOOLEAN
          ]
        },

        has_pet_name: {
          type: FIELD_TYPES.BOOLEAN,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.BOOLEAN
          ]
        },

        message_length: {
          type: FIELD_TYPES.NUMBER,
          required: true,
          analytics: 'metric',
          normalize: [
            NORMALIZERS.NUMBER
          ],
          minimum: 0
        },

        form_location: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        },

        section_name: {
          type: FIELD_TYPES.STRING,
          required: false,
          analytics: 'dimension',
          normalize: [
            NORMALIZERS.TRIM
          ]
        }
      }
    }
  };

  const aliases = {
    section: 'section_name',

    sectionName: 'section_name',

    sectionIndex: 'section_index',

    sectionId: 'section_id',

    sectionType: 'section_type',

    sectionSource: 'section_source',

    sectionSelector: 'section_selector',

    visibilityRatio: 'visibility_ratio',

    visibleMs: 'visible_ms',

    clickLocation: 'click_location',

    ctaLabel: 'cta_label',

    phone: 'phone_number',

    email: 'email_address',

    messageLength: 'message_length',

    hasPhone: 'has_phone',

    hasEmail: 'has_email',

    hasPetName: 'has_pet_name'
  };

  function clone(value) {
    return JSON.parse(
      JSON.stringify(value)
    );
  }

  function mergeSchemas(
    baseSchema,
    childSchema
  ) {
    return {
      category:
        childSchema.category ||
        baseSchema.category ||
        '',

      required: Array.from(
        new Set(
          []
            .concat(
              baseSchema.required || []
            )
            .concat(
              childSchema.required || []
            )
        )
      ),

      optional: Array.from(
        new Set(
          []
            .concat(
              baseSchema.optional || []
            )
            .concat(
              childSchema.optional || []
            )
        )
      ),

      fields: Object.assign(
        {},
        baseSchema.fields || {},
        childSchema.fields || {}
      )
    };
  }

  function getEventSchema(
    eventName
  ) {
    const schema =
      eventSchemas[eventName];

    if (!schema) {
      return null;
    }

    if (!schema.inherit) {
      return clone(schema);
    }

    const parent =
      eventSchemas[
        schema.inherit
      ];

    if (!parent) {
      return clone(schema);
    }

    return mergeSchemas(
      parent,
      schema
    );
  }

  function getFieldDefinition(
    eventName,
    fieldName
  ) {
    if (coreFields[fieldName]) {
      return clone(
        coreFields[fieldName]
      );
    }

    const eventSchema =
      getEventSchema(
        eventName
      );

    if (
      eventSchema &&
      eventSchema.fields &&
      eventSchema.fields[fieldName]
    ) {
      return clone(
        eventSchema.fields[
          fieldName
        ]
      );
    }

    return null;
  }

  function getRequiredFields(
    eventName
  ) {
    const eventSchema =
      getEventSchema(
        eventName
      );

    const coreRequired =
      Object.keys(coreFields)
        .filter(
          function (fieldName) {
            return (
              coreFields[fieldName]
                .required === true
            );
          }
        );

    const eventRequired =
      eventSchema &&
      Array.isArray(
        eventSchema.required
      )
        ? eventSchema.required
        : [];

    return Array.from(
      new Set(
        coreRequired.concat(
          eventRequired
        )
      )
    );
  }

  function getAllowedFields(
    eventName
  ) {
    const eventSchema =
      getEventSchema(
        eventName
      );

    const fields =
      Object.keys(coreFields);

    if (
      eventSchema &&
      eventSchema.fields
    ) {
      fields.push.apply(
        fields,
        Object.keys(
          eventSchema.fields
        )
      );
    }

    return Array.from(
      new Set(fields)
    );
  }

  function getAlias(
    fieldName
  ) {
    return (
      aliases[fieldName] ||
      null
    );
  }

  function getAnalyticsMap(
    eventName
  ) {
    const result = {};

    getAllowedFields(eventName)
      .forEach(
        function (fieldName) {
          const definition =
            getFieldDefinition(
              eventName,
              fieldName
            );

          result[fieldName] =
            definition &&
            definition.analytics
              ? definition.analytics
              : 'unclassified';
        }
      );

    return result;
  }

  function getNormalizationRules(
    eventName,
    fieldName
  ) {
    const definition =
      getFieldDefinition(
        eventName,
        fieldName
      );

    if (
      !definition ||
      !Array.isArray(
        definition.normalize
      )
    ) {
      return [];
    }

    return clone(
      definition.normalize
    );
  }

  function getNormalizationMap(
    eventName
  ) {
    const result = {};

    getAllowedFields(eventName)
      .forEach(
        function (fieldName) {
          result[fieldName] =
            getNormalizationRules(
              eventName,
              fieldName
            );
        }
      );

    return result;
  }

  window.UnifiedSchema = {
    version:
      VERSION,

    types:
      FIELD_TYPES,

    normalizers:
      NORMALIZERS,

    coreFields:
      clone(coreFields),

    events:
      clone(eventSchemas),

    aliases:
      clone(aliases),

    getEventSchema:
      getEventSchema,

    getFieldDefinition:
      getFieldDefinition,

    getRequiredFields:
      getRequiredFields,

    getAllowedFields:
      getAllowedFields,

    getAlias:
      getAlias,

    getAnalyticsMap:
      getAnalyticsMap,

    getNormalizationRules:
      getNormalizationRules,

    getNormalizationMap:
      getNormalizationMap
  };

  if (
    window.UnifiedTrackingConfig &&
    window.UnifiedTrackingConfig.debug
  ) {
    console.info(
      '[Unified Schema] Analytics Contract initialized',
      {
        version:
          VERSION,

        coreFields:
          Object.keys(
            coreFields
          ).length,

        events:
          Object.keys(
            eventSchemas
          ).length,

        normalizers:
          Object.keys(
            NORMALIZERS
          ).length
      }
    );
  }
})();